// Remaining time until an ISO timestamp, as "m:ss", ticking once a second while mounted.
export const useCountdown = (until: Ref<string | null | undefined>) => {
    const now = ref(Date.now())
    let timer: ReturnType<typeof setInterval> | null = null

    const remainingSeconds = computed(() => {
        if (!until.value) return 0
        return Math.max(0, Math.floor((new Date(until.value).getTime() - now.value) / 1000))
    })

    const label = computed(() => {
        const seconds = remainingSeconds.value
        return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0')
    })

    onMounted(() => {
        timer = setInterval(() => { now.value = Date.now() }, 1000)
    })

    onBeforeUnmount(() => {
        if (timer) clearInterval(timer)
    })

    return {remainingSeconds, label}
}
